/**
 * Конфигурация шагов мини-туториалов для разных страниц
 */

// Шаги для редактора опросов (/surveys/editor)
export const SURVEY_EDITOR_STEPS = [
    {
        id: 'survey-title',
        title: 'Название и описание',
        content: 'Введите название опроса и описание. Это поможет пациентам понять, о чём этот опрос.',
        target: '.survey-editor-header, .editor-title-input, h1',
        position: 'bottom',
    },
    {
        id: 'survey-questions',
        title: 'Список вопросов',
        content: 'Здесь отображаются все вопросы опроса. Вы можете менять их порядок или удалять.',
        target: '.questions-list, .survey-questions-list, .questions-container',
        position: 'center',
    },
    {
        id: 'survey-reorder',
        title: 'Изменение порядка',
        content: 'Используйте стрелки ↑ ↓ для изменения порядка вопросов в опросе.',
        target: '.reorder-buttons, .btn-reorder, .question-order-controls',
        position: 'left',
    },
    {
        id: 'survey-add',
        title: 'Добавление вопросов',
        content: 'Нажмите "+ Добавить вопрос" чтобы добавить существующий вопрос из базы.',
        target: '.btn-add-question, .add-question-btn, .add-question-button',
        position: 'top',
    },
    {
        id: 'survey-save',
        title: 'Сохранение',
        content: 'Не забудьте сохранить опрос! Нажмите кнопку "Сохранить" когда закончите редактирование.',
        target: '.btn-save, .save-button',
        position: 'bottom',
    },
];

// Шаги для редактора вопросов (/questions/editor)
export const QUESTION_EDITOR_STEPS = [
    {
        id: 'question-text',
        title: 'Текст вопроса',
        content: 'Введите текст вопроса, который увидит пациент. Формулируйте чётко и понятно.',
        target: '.question-text-input, textarea[name="text"], .question-form textarea',
        position: 'bottom',
    },
    {
        id: 'question-public',
        title: 'Публичность вопроса',
        content: 'Если сделать вопрос публичным, другие врачи смогут использовать его в своих опросах.',
        target: '.public-checkbox, .is-public-toggle, input[type="checkbox"]',
        position: 'right',
    },
    {
        id: 'question-options',
        title: 'Варианты ответа',
        content: 'Добавьте варианты ответа для вопроса с выбором. Нажмите "+" чтобы добавить ещё один.',
        target: '.answer-options, .options-list, .question-options',
        position: 'center',
    },
    {
        id: 'question-media',
        title: 'Изображение и голос',
        content: 'Можно добавить изображение или голосовое пояснение к вопросу для большей наглядности.',
        target: '.media-upload, .upload-buttons, .question-media',
        position: 'top',
    },
    {
        id: 'question-save',
        title: 'Сохранение',
        content: 'Сохраните вопрос, чтобы использовать его в опросах.',
        target: '.btn-save, .save-button, .editor-actions button:last-child',
        position: 'bottom',
    },
];

// Шаги для страницы лекарств пациента (/patients/medications)
export const PATIENT_MEDICATIONS_STEPS = [
    {
        id: 'med-list',
        title: 'Список лекарств',
        content: 'Здесь отображаются все назначенные пациенту лекарства и их расписание.',
        target: '.medications-list, .medication-cards, .medications-container',
        position: 'center',
    },
    {
        id: 'med-add',
        title: 'Добавление лекарства',
        content: 'Нажмите "+ Добавить лекарство" чтобы назначить новое лекарство пациенту.',
        target: '.btn-add-medication, .add-medication-btn, .btn-create',
        position: 'bottom',
    },
    {
        id: 'med-form-name',
        title: 'Название и дозировка',
        content: 'Введите название лекарства и дозировку (например: "Аспирин 100мг").',
        target: '.medication-name-input, input[name="name"], .medication-form .form-field:first-child',
        position: 'bottom',
    },
    {
        id: 'med-form-frequency',
        title: 'Частота приёма',
        content: 'Выберите, как часто нужно принимать лекарство: раз в день, несколько раз, или по дням недели.',
        target: '.frequency-selector, .frequency-options, select[name="frequency"]',
        position: 'top',
    },
    {
        id: 'med-form-time',
        title: 'Время приёма',
        content: 'Укажите время, когда пациент должен принимать лекарство. Можно добавить несколько времен.',
        target: '.time-selector, .scheduled-times, .time-inputs',
        position: 'top',
    },
    {
        id: 'med-save',
        title: 'Сохранение',
        content: 'Сохраните назначение. Пациент получит напоминания в указанное время.',
        target: '.btn-save, .submit-button, .drawer-footer-actions .btn-primary',
        position: 'bottom',
    },
];

// Шаги для страницы назначенных опросов (/patients/scheduled)
export const PATIENT_SCHEDULED_STEPS = [
    {
        id: 'scheduled-list',
        title: 'Назначенные опросы',
        content: 'Здесь показаны все опросы, назначенные пациенту по расписанию.',
        target: '.scheduled-list, .scheduled-grid, .scheduled-container',
        position: 'center',
    },
    {
        id: 'scheduled-add',
        title: 'Назначить опрос',
        content: 'Нажмите "Назначить опрос" чтобы добавить новое назначение.',
        target: '.btn-create-schedule, .btn-schedule, .btn-create',
        position: 'bottom',
    },
    {
        id: 'scheduled-select',
        title: 'Выбор опроса',
        content: 'Выберите опрос из списка ваших созданных опросов. Показаны только активные (не черновики).',
        target: '.survey-selection, .survey-list, .select-survey',
        position: 'center',
    },
    {
        id: 'scheduled-settings',
        title: 'Настройки назначения',
        content: 'Задайте название назначения и описание для пациента.',
        target: '.schedule-settings, .assignment-settings, .settings-form',
        position: 'center',
    },
    {
        id: 'scheduled-frequency',
        title: 'Расписание',
        content: 'Настройте частоту прохождения: раз в день, по дням недели, или с интервалом.',
        target: '.frequency-settings, .schedule-frequency, .frequency-selector',
        position: 'top',
    },
    {
        id: 'scheduled-save',
        title: 'Сохранение',
        content: 'Сохраните назначение. Опрос будет автоматически появляться у пациента по расписанию.',
        target: '.btn-save, .submit-button, .drawer-footer-actions .btn-primary',
        position: 'bottom',
    },
];
